import { restore, restoreWithSubscribe } from './backup';

export const backup = {
    restore,
    restoreWithSubscribe,
};
